export enum MessageLifetime {
    /// <summary>
    /// Message is displayed for a set period of time, then automatically closes.  
    /// User can also manually dismiss.
    /// Use for low-importance messages, such as update confirmation messages
    /// </summary>
    timer = 0,
    /// <summary>
    /// Message is displayed unless closed by code or if dismissed by the user.
    /// </summary>
    untilDismissed = 1,
    /// <summary>
    /// Message is displayed permanently, unless closed by code. User cannot dismiss.
    /// Normally reserved for critical messages
    /// </summary>
    permanent = 2
}

export enum MessageType {
    info = 0,
    success = 1,
    warning = 2,
    error = 3,
    critical = 4
}

export enum MessageScope {
    /// <summary>
    /// Message is displayed only within the current page.
    /// </summary>
    page = 0,
    /// <summary>
    /// Message is displayed throughout entire the application
    /// </summary>
    application = 1
}

export class Message {
    static _messageIdx: number = 0;
    isHtml: boolean;

    constructor() {
        this.messageId = Message._messageIdx++;
    }
    containerId: string = "root";
    messageId: number;
    content: string;
    type: MessageType = MessageType.info;
    lifetime: MessageLifetime = MessageLifetime.timer;
    scope: MessageScope = MessageScope.page;
    data: any;  //place to store caller data
    key: string;    //use the key to ensure that the message is only diplayed once
}
